import { CUSTOM_OKTA_STORAGE_KEY } from "../models/oktaConstants";

const SESSION_STARTED_KEY = `${CUSTOM_OKTA_STORAGE_KEY}-session-started`;

export function setSessionStartNow() {
  window.localStorage.setItem(SESSION_STARTED_KEY, `${Date.now()}`);
}

export function getSessionStartDate() {
  const raw = window.localStorage.getItem(SESSION_STARTED_KEY);
  if (!raw) {
    return null;
  }

  const parsed = parseInt(raw, 10);
  if (!parsed || isNaN(parsed)) {
    return null;
  }

  return new Date(parsed);
}
